<script setup>
import { computed, inject } from 'vue';
import PVInputText from 'primevue/inputtext';
import { cn } from '@/lib/utils';

defineOptions({ inheritAttrs: false });

const props = defineProps({
    class: String,
    type: { type: String, default: 'text' },
    placeholder: String,
    disabled: Boolean,
    modelValue: [String, Number],
});

defineEmits(['update:modelValue']);

// Powiązanie z etykietą, gdy owinięty w <Field>
const fieldId = inject('fieldId', null);

// Klasy pola z kanonu nova (ui-nova/input) — gęste h-8, rounded-lg, ring-3
const pt = computed(() => ({
    root: cn(
        'flex h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base md:text-sm',
        'transition-colors outline-none placeholder:text-muted-foreground dark:bg-input/30',
        'focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-input/50 dark:disabled:bg-input/80',
        props.class,
    ),
}));
</script>

<template>
    <PVInputText
        v-bind="$attrs"
        :id="$attrs.id ?? fieldId"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :model-value="modelValue"
        :pt="pt"
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>
